var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('b-field',{attrs:{"label":_vm.label}},[_c('b-select',{attrs:{"multiple":_vm.multiple,"expanded":""},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}},[_vm._t("default")],2)],1),_c('b-button',{attrs:{"type":"is-primary"},on:{"click":function($event){return _vm.$emit('update', {
                key: _vm.configKey,
                data: _vm.form,
                type: 'select',
                multiple: _vm.multiple
            })}}},[_vm._v(" Modifier ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }